module.exports = __webpack_public_path__ + "img/notes.6ced2a5c.png";